import React from 'react';
import ReactDOM from 'react-dom';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/inter/900.css';
import './index.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
